import { render, staticRenderFns } from "./commdityList2.vue?vue&type=template&id=60b7670c&scoped=true&"
import script from "./commdityList2.vue?vue&type=script&lang=js&"
export * from "./commdityList2.vue?vue&type=script&lang=js&"
import style0 from "./commdityList2.vue?vue&type=style&index=0&id=60b7670c&lang=scss&scoped=true&"
import style1 from "./commdityList2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b7670c",
  null
  
)

export default component.exports